import React from "react"
import AgeStyle from "./AgeStyle.module.css"
import WeightStyle from "../weight/WeightStyle.module.css"
import translate, { keys } from "../../../../../translation/translator"

const Age = ({ age, handleChangeAge, locale }) => {
  return (
    <div className={AgeStyle.holder}>
      <p className={AgeStyle.age_title}>
        5. {translate(keys.WHAT_IS_YOUR_AGE, locale)}
      </p>
      <div className={AgeStyle.input_holder}>
        <input
          type="text"
          onChange={handleChangeAge}
          value={age}
          placeholder={translate(keys.YEARS, locale)}
        />
        {age.length > 0 ? (
          <span className={AgeStyle.placeholder}>
            {translate(keys.YEARS, locale)}
          </span>
        ) : null}
      </div>

      {age < 18 || age > 110 ? (
        <div className={WeightStyle.weight_popup}>
          <span>{translate(keys.YEARS_POPUP, locale)}</span>
        </div>
      ) : null}
    </div>
  )
}

export default Age
